module.exports = __webpack_public_path__ + "static/media/10ton-variant-2.c22e4627.jpg";